import { DUR, EASE } from '@/animations/settings/vars'
import { gsap } from '@gsap'

const animateTopBar = (comp: any, tl: any) => {
  if (!comp.current) {
    return
  }

  gsap.set('[data-nav-overlay]', {
    autoAlpha: 0,
    display: 'block'
  })

  tl.current = gsap
    .timeline({
      paused: true,
      defaults: { ease: EASE.expoOut, duration: DUR.goldenRatio }
    })
    .to('[data-topbar-button]', {
      autoAlpha: 0,
      x: '1rem',
      duration: 0.6,
      stagger: 0.1,
      ease: EASE.in
    })
    .to(
      '[data-topbar-bg]',
      {
        right: '0%',
        ease: EASE.expoOut
      },
      '<'
    )
    .to(
      '[data-nav-overlay]',
      { autoAlpha: 1, duration: 0.4, ease: 'none' },
      '<+=0.2'
    )
    .from('[data-search-input-mobile]', {
      autoAlpha: 0,
      x: '-1rem',
      duration: 0.6
    })
}

const animateNav = (comp: any, tl: any, version: 'desktop' | 'mobile') => {
  if (!comp.current) {
    return
  }
  gsap.set(comp.current, { pointerEvents: 'none', autoAlpha: 0 })
  gsap.set('[data-navigation-menu-viewport]', { autoAlpha: 0, x: '-1rem' })

  tl.current = gsap
    .timeline({
      paused: true,
      defaults: { ease: EASE.expoOut, duration: DUR.goldenRatio },
      onReverseComplete: () => {
        gsap.set(comp.current, { pointerEvents: 'none', autoAlpha: 0 })
      }
    })
    .set(comp.current, { pointerEvents: 'auto', autoAlpha: 1 })
    .from(
      `[data-nav-menu-${version}] > ul > li, [data-nav-menu-${version}] > div > ul > li, [data-lang-switch-${version}]`,
      {
        autoAlpha: 0,
        x: '-0.8rem',
        stagger: 0.15,
        delay: 0.8
      }
    )
    .to(
      '[data-navigation-menu-viewport]',
      {
        autoAlpha: 1,
        duration: 0.8,
        x: 0
      },
      '<+=0.4'
    )
}

export { animateNav, animateTopBar }
